import { makeStyles } from '@material-ui/styles';
import { alpha } from '@material-ui/core/styles/colorManipulator';

export default makeStyles((theme) => ({
  titulo: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    },
  },
  link: {
    marginTop: 20,
    '&:not(:first-child)': {
      paddingLeft: 15
    },
  },
  dev: {
    filter: 'grayscale(1)',
    width: 100,
    opacity: 0.2,
    transition: '0.2s all ease-in-out',
    '&:hover': {
      filter: 'grayscale(0)',
      opacity: 1,
    }
  }
}));
